// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xCZzh","toggle":"styles_toggle__29bLm","preview":"styles_preview__3XJz-"};